import { Card, CardContent, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";
import { useEffect, useState } from "react";
import apiService from "../../../../../../service/Api";

interface TopSuburbItem {
  suburb: string;
  total_capacity: number;
  venue_count: number;
  avg_capacity: number;
}

interface TopSuburbsResponse {
  data: TopSuburbItem[];
  total_suburbs: number;
  title: string;
}

export default function TopSuburbsByCapacityWidget() {
  const [suburbs, setSuburbs] = useState<string[]>([]);
  const [capacities, setCapacities] = useState<number[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await apiService.get<TopSuburbsResponse>(
          "/api/venues/dashboard/top-suburbs-by-capacity/"
        );

        const items = res.data?.data ?? [];

        setSuburbs(items.map((item) => item.suburb || "Unknown"));
        setCapacities(items.map((item) => item.total_capacity));
      } catch (error) {
        console.error("Failed to load top suburbs by capacity", error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <Card sx={{ height: "100%", borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Top 10 Suburbs by Capacity
        </Typography>

        <BarChart
          layout="horizontal" // horizontal bars
          height={Math.max(300, suburbs.length * 30)} // dynamic height
          yAxis={[
            {
              data: suburbs, // suburb names
              scaleType: "band",
              width: 160, // enough space for long names
            },
          ]}
          xAxis={[
            {
              label: "Capacity",
              valueFormatter: (value: number) => value.toString(), // removes commas
            },
          ]}
          series={[
            {
              data: capacities,
            },
          ]}
        />
      </CardContent>
    </Card>
  );
}
